<div *ngIf="loading" class="flex flex-column justify-center align-center h-100 text-center family-info">
  <app-loader></app-loader>
  <p class="para-title">
    Submitting your request
  </p>
</div>

<div *ngIf="!loading" class="flex flex-column justify-center align-center h-100 text-center family-info">
  <h1 class="para-title">
    Kindly click the button below to send us a confirmation message on whatsapp
  </h1>

  <div class="twelve wide column mt-5">
    <button (click)="sendChat()" class="ui button positive">
      <i class="fab fa-whatsapp mr-3"></i>
      Send whatsapp message
    </button>
  </div>
</div>
